import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import elements
import Breadcrumb from '../elements/Breadcrumb';
// import components
import Main from '../components/Home';
// import data
import {mainTitle, announcement} from '../assets/constants/home';
import {sideMenuItems} from '../assets/constants/sideMenu';

class HomePage extends React.Component{

  render(){
    return (       
      <div css={css`
        width: 98%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
      `}>   
        <div css={css`
          width: 100%;
          margin: 10px;
          flex-grow: 0;
        `}>
          <Breadcrumb label={this.props.breadcrumbLabel} />
        </div>
        <div css={css`
          width: 100%;
          margin: 10px;
          flex-grow: 1;
          padding: 30px;
          border-radius: 2px;
          background-color: rgba(143, 206, 238, 0.1);
        `}>
          <div css={css`
            text-align: center;
            padding: 20px;
          `}>
            <div css={css`
              font-size: 1.5rem;
              font-weight: 700;
            `}>{mainTitle.title}</div>
            <div css={css`
              font-size: 1.1rem;
              font-weight: 500;
            `}>{mainTitle.subTitle}</div>
          </div>
          <Main 
            sideMenuItems={sideMenuItems} />
        </div>
      </div>)
  }
}

export default HomePage;